import { sendGAEvent } from '@next/third-parties/google';
import { GA_ID, SITE } from '@/app/constants';
import { reportEvent } from '@/app/utils';
import { getDeviceId, getMetaPixelCookies, processReferrer } from '@/app/utils/client';
import { tracksUpdate } from './apis';

// 给 GA 上报更新跟踪信息
export const updateTrack = () => {
  // 使用processReferrer获取完整的UTM参数（已包含URL参数和referrer处理）
  const utmParams = processReferrer();

  // 提取需要的参数
  const utmSource = utmParams.utm_source || '';
  const utmMedium = utmParams.utm_medium || '';
  const utmCampaign = utmParams.utm_campaign || '';
  // 从processReferrer返回结果中获取，避免重复获取
  const utmTerm = utmParams.utm_term || ''; // 有特殊用途的参数
  const utmContent = utmParams.utm_content || '';

  reportTrack({
    utmSource,
    utmMedium,
    utmCampaign,
    utmTerm,
    utmContent,
  });
};

interface ReportTrackProps {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent?: string;
}

export const reportTrack = ({ utmSource, utmMedium, utmCampaign, utmTerm, utmContent = '' }: ReportTrackProps) => {
  const deviceId = getDeviceId();

  const searchParams = new URLSearchParams(window.location.search);
  const logidUrl = searchParams.get('bd_vid') ? window.location.href : '';
  const click_id = searchParams.get('rdt_cid') ?? '';

  // 获取 Meta Pixel Cookie 值
  const { fbp, fbc } = getMetaPixelCookies();

  if (SITE === 'global') {
    // 确保 dataLayer 存在
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    sendGAEvent('get', GA_ID, 'client_id', (clientId: string) => {
      tracksUpdate({
        body: {
          device_id: deviceId,
          meta_data: {
            utm_source: utmSource,
            utm_campaign: utmCampaign,
            utm_term: utmTerm,
            utm_content: utmContent,
            utm_medium: utmMedium,
            client_id: clientId,
            click_id,
            //后端处理复杂 下游流程里只处理metadata
            uuid: deviceId,
            fbp,
            fbc,
          },
        },
      }).catch((error) => {
        reportEvent('api_error', {
          api_url: 'tracksUpdate',
          api_error_name: error.name,
          api_error_message: error.message,
        });
      });
    });
  } else if (SITE === 'china') {
    tracksUpdate({
      body: {
        device_id: deviceId,
        meta_data: {
          utm_source: utmSource,
          utm_campaign: utmCampaign,
          utm_term: utmTerm,
          utm_content: utmContent,
          utm_medium: utmMedium,
          logidUrl,
        },
      },
    }).catch((error) => {
      reportEvent('api_error', {
        api_url: 'tracksUpdate',
        api_error_name: error.name,
        api_error_message: error.message,
      });
    });
  }
};
